import { client } from '../../..'
import { DECLINE_REQUESTED_MEETING } from '../MeetingMutations'
import { DeclineRequestedMeetingMutation, DeclineRequestedMeetingMutationVariables } from '../../../types'
import { GET_MEETING_REQUESTS_BY_REVIEWER, MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'
import { FetchResult } from '@apollo/client'

export default (): {
  declineMeetingRequest: (
    requestedMeetingId: number,
    reasonOfRejection: string,
    reviewerId?: number,
    requesterId?: number,
  ) => Promise<FetchResult<DeclineRequestedMeetingMutation>>
} => {
  const declineMeetingRequest = async (
    requestedMeetingId: number,
    reasonOfRejection: string,
    reviewerId?: number,
    requesterId?: number,
  ) => {
    const refetchQueries = reviewerId
      ? [
          {
            query: GET_MEETING_REQUESTS_BY_REVIEWER, // Requested Meetings Tab in Meeting View
            variables: {
              reviewerId: reviewerId,
            },
          },
        ]
      : requesterId
      ? [
          {
            query: MEETINGS_AND_REQUESTS_BY_REPLYER, // Meetings Tab in Public Profile
            variables: {
              replyerId: requesterId,
            },
          },
        ]
      : undefined

    return await client.mutate<DeclineRequestedMeetingMutation, DeclineRequestedMeetingMutationVariables>({
      mutation: DECLINE_REQUESTED_MEETING,
      variables: {
        requestedMeetingId: requestedMeetingId,
        reasonOfRejection: reasonOfRejection,
      },
      refetchQueries: refetchQueries,
      awaitRefetchQueries: !!refetchQueries,
    })
  }

  return { declineMeetingRequest }
}
